import { useNavigate } from 'react-router-dom';
import { Button } from '@peacecover/component';
import { useQueryParams } from '../../utils/useQueryParams';
import { ReactComponent as RainbowCheckCircleFill } from '../../icons/rainbow.check.circle.fill.svg';
import { formatDateTime } from '../../utils/DateUtil';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

const SubscriptionCancelSuccessPage = () => {
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const cancelDate = queryParams.get('cancel_date');
  const formatCancelDate = formatDateTime(cancelDate, 'PPP');
  
  const handleClick = () => {
    navigate('/bettie/purchase-history', { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <RainbowCheckCircleFill width={94} height={94} />
      <h1 className="text-[24px] font-bold text-text-main-lv1 leading-[29px] mt-[42px]">
        {t('SubscriptionCancelSuccess.title')}
      </h1>
      <p className="text-[13px] font-medium text-text-main-lv4 leading-[16px] text-center mt-[14px] whitespace-pre-line">
        <Trans
          i18nKey="SubscriptionCancelSuccess.description"
          components={{
            span: <span className="font-semibold" />
          }}
          values={{
            date: formatCancelDate
          }}
        />
      </p>
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px]"
          onClick={handleClick}
        >
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionCancelSuccessPage;
